import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { AuthService } from '@shared/services/auth.service'
import { Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  private auth = inject(AuthService)
  private router = inject(Router)

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
    return this.auth.isAuthenticated() ? true : this.router.parseUrl('/dashboard/login')
  }
}
